import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import $ from "jquery";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import VehicleOverView from "@/pages/vehicles/vehicleoverview/vehicleoverview";
import VehicleMaps from '@/pages/vehicles/vehiclemaps/vehiclemaps.vue';
import Task from "@/pages/task/task";
import { googleMapApiKey } from "@/constants/config";
import VehicleAssetsPopup from '@/pages/vehicles/vehicleassetpopup/vehicleassetpopup.vue';
var moment = require("moment");
export default {
  components: {
    UpcomingEvent,
    VuePerfectScrollbar,
    VehicleOverView,
    VehicleMaps,
    Task,
    VehicleAssetsPopup
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
    region: function (data) {
      return VehicleRegistrationRegion(data);
    },
  },
  data() {
    return {
      trackingModule: false,
      settings4: {
        maxScrollbarLength: 60,
        suppressScrollY: true,
      },
      CompanyData: "",
      SearchLoader: false,
      ShowLoader: false,
	    UnsafeShowLoader: false,
      trailersModule: false,
      assetsModule: false,
      ShowTrailerDetailPopup: false,
      SearchKey: "",
      VehicleImageEndpoint: Endpoints.Helper.GenerateImage + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      Vehicles: [],
      Drivers: [],
      TrailerData: [],
      Groups:[],
      vehicle_export_data:[],
      AssginVehicle: { driver_id: 0, vehicle_id: 0 },
      UpcomingEvent: {},
      DashboardData: {},
      DashboardDetailHeading: "",
      VehicleWarningCnt: 0,
      Branches: {},
      Make: {},
      Models: {},
      VehicleTypes: {},
      DashboardReportData:{},
      SearchData: {
        branch_id: "",
        vehicle_group: "",
        vehicle_type: "",
        vehicle_assigned: "",
        vehicle_status: "",
        make: "",
        model: "",
      },

      VehiclePositionModelVehicleId: 0,
      ShowVehiclePositionModel: false,
      LastVehiclePosition: {},
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      locationMarkers: [],
      ActivityPage: 1,
      LastPageRequest: 0,
      scrollThreshold: 200,
      isScrollBottom: false,
      
      ShowVehicleDetails: false,
      ShowUrgentTask: false,
      VehicleListLoaded: false,
      FleetSubscription:[],
      lastUpdatedPosition:"",
      todaysUrgentTaskNew: window.todaysUrgentTaskNew,
      ShowVehicleAssetsModel: false,
      AssetsList:[],
      ShowAssetsDetails:false,
    };
  },
  mounted() {
    //check account permission
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    this.FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(
      this.FleetSubscription.fleet_modules
    );
    if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Vehicle || !AccountPermissions.Vehicle.enable)){
      this.$router.push('/');
    }

    if (AccountPermissions && 
      AccountPermissions.Vehicle &&
      AccountPermissions.Vehicle.enable) {
      if (AccountPermissions.Vehicle.view) {
        this.ShowVehicleDetails = true;
      }
    }

    if (AccountPermissions && 
			AccountPermissions['Vehicle Checks'] &&
			AccountPermissions['Vehicle Checks']['enable']) {
			if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
				this.ShowUrgentTask = true;
			}
		}

		if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowUrgentTask = true;
        this.ShowVehicleDetails = true;
        this.ShowAssetsDetails = true;
		}

    this.CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (this.CompanyData && this.CompanyData.name) {            
      if(window.taskModuleCompanies.includes(this.CompanyData.id)){ 
      	this.todaysUrgentTaskNew = true
      }
    } 
    document.title = pbx_SiteTitle + " - Vehicles List";
    //this.GetCompanySubscription();
    this.GetGroups();
    this.GetCompanySubscriptionModule();
    this.GetVehiclesList();
    this.GetUnSafeVehicle();
    this.GetBranches();
    this.GetMake();
    this.GetVehicleTypes();
    $(".closeDashboardDetail").on("click", function (event) {
      $("#DashboardDetailPopup").hide();
    });
    //window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    //window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    GetGroups() {
      var obj = {
        token: localStorage.getItem("token"),
      };
      Axios.post(Endpoints.Groups.List, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.Groups = Response.data.records;
        }
      });
    },
    handleScroll() {
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const clientHeight = document.documentElement.clientHeight;

      if (scrollHeight - scrollTop - clientHeight < this.scrollThreshold) {
        // Scroll reached the bottom
        if (!this.isScrollBottom) {
          this.isScrollBottom = true;
          this.GetVehiclesList("search"); // Call your method here
        }
      } else {
        this.isScrollBottom = false;
      }
    },
    GetUnSafeVehicle() {
      Axios.post(Endpoints.Dashboard.DashboardReportData, {
        token: localStorage.getItem("token"),
        type: 'vehicleunsafe',
        item_type:'VehicleList'
      }).then((Response) => {
        if (Response?.data?.success) {
          this.DashboardReportData = Response.data.DashboardReportData;
        }
      });
    },
    GetCompanySubscriptionModule(){
    	var FleetSubscription = JSON.parse(localStorage.getItem("FleetSubscription"));
    	var fleet_modules = JSON.parse(FleetSubscription['fleet_modules']);    	
    	const isTrailer = fleet_modules['Trailers'];
		if (isTrailer) {
			this.trailersModule = true;
		}
		const isTracking = fleet_modules['Vehicle Tracking'];
		if (isTracking) {
			this.trackingModule = true;
		}
    const isAsset = fleet_modules['Assets'];
		if (isAsset) {
			this.assetsModule = true;
		}
    },
    GetCompanySubscription() {
      var FleetSubscriptionModules = JSON.parse(
				JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
			);
      const isTrailer = FleetSubscriptionModules.Trailers;
      if (isTrailer) {
        this.trailersModule = true;
      }
      const isTracking = FleetSubscriptionModules["Vehicle Tracking"];
      if (isTracking) {
        this.trackingModule = true;
      }
    },
    SetTrailerInfo(TrailerId) {
      Axios.post(Endpoints.Trailer.Get, {
        token: localStorage.getItem("token"),
        trailer_id: TrailerId,
      }).then((Response) => {
        if (Response?.data?.success) {
          this.TrailerData = Response.data.trailer;
        }else{
          this.$router.push("/error-404");
        }
      });
      this.ShowTrailerDetailPopup = true;
    },
    GetBranches() {
      var obj = { token: localStorage.getItem("token"), select_branch: true };
      Axios.post(Endpoints.Branch.List, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Branches = Response.data.records;
        }
      });
    },
    GetMake() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Vehicle.GetVehicleMake, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Make = Response.data.records;
        }
      });
    },
    GetModel() {
      var obj = {
        token: localStorage.getItem("token"),
        make: this.SearchData.make,
      };
      Axios.post(Endpoints.Vehicle.GetVehicleModel, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Models = Response.data.records;
        }
      });
    },
    GetVehicleTypes() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Vehicle.GetVehicleTypes, obj).then((Response) => {
        if (Response?.data?.success) {
          this.VehicleTypes = Response.data.records;
        }
      });
    },
   
    SearchVehicle(type = null) {
      if (type == "make") {
        this.SearchData.model = "";
        if (this.SearchData.make == "") {
          this.Models = [];
        }
      }

      this.Vehicles = [];
      this.ActivityPage = 1;
      this.LastPageRequest = 0;
      this.GetVehiclesList("search");
    },
    GetVehiclesList(type = "") {
      var self = this;
      if (this.ActivityPage > 0 && this.LastPageRequest != this.ActivityPage) {
        this.SearchLoader = true;
        this.LastPageRequest = this.ActivityPage;
        var obj = {
          token: localStorage.getItem("token"),
          paginate:true,
          page:this.ActivityPage
        };
        if (type == "search") {
          if (this.SearchKey != "") {
            obj.searchkey = this.SearchKey;
          }
          obj.SearchData = this.SearchData;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.Vehicle.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.SearchLoader = false;
            //this.Vehicles = Response.data.vehicles;
           /*  if (Response.data.vehicles.data.length > 0) {
              Response.data.vehicles.data.forEach((record) => {
                self.Vehicles.push(record);
              });
            } */
            if (Response?.data?.vehicles?.data != "") {
              Object.values(Response?.data?.vehicles?.data || {}).forEach((record) => {
                self.Vehicles.push(record);
              });
            }
            this.vehicle_export_data = [];
            if (this.Vehicles.length > 0) {
              this.Vehicles.forEach((element2) => {
                var obj = {};
                obj["VRM"] = element2.vrm;
                obj["Make"] = element2.make;
                obj["Model"] = element2.model;
                if(element2.isMotExpired){
                  obj["MOT Exp"] = 'Expired';
                }else{
                  obj["MOT Exp"] = this.$options.filters.date(element2.mot_due);
                }
                
                obj["Tax Exp"] = this.$options.filters.date(element2.tax_due);
                this.vehicle_export_data.push(obj);
              });
            }
            if((Response?.data?.nextPage || 0) > 0){
              this.ActivityPage = Response.data.nextPage;
              this.GetVehiclesList('search');
            }
            if((Response?.data?.nextPage || 0) == 0){
            	//this.GetVehiclesListWithSafeStatus();
            	this.VehicleListLoaded = true;
            }
          }
        }).catch((error) => {
          this.ShowLoader = false;
          this.SearchLoader = false;
          console.error("Error fetching vehicles list:", error);
        });
      }
    },
    GetVehiclesListWithSafeStatus() {     
        var obj = {
          token: localStorage.getItem("token"),         
        };                
        Axios.post(Endpoints.Vehicle.ListWithSafeStatus, obj).then((Response) => {        
          if (Response?.data?.success) {          	            
            Response.data.vehicles.forEach((record) => {
                this.Vehicles.forEach((record2,index2) => {
                	if(record.id == record2.id){
                		this.Vehicles[index2]['last_vehicle_check'] = record['last_vehicle_check']
                		this.Vehicles[index2]['warning'] = record['warning']
                		this.Vehicles[index2]['unsafe'] = record['unsafe']
                	}
              	});
            });                                             
          }
        });      
    },
    AssignDriver(vehicle_id) {
      this.AssginVehicle.vehicle_id = vehicle_id;
      this.AssginVehicle.driver_id = 0;
    },
    ShowVehiclePosition(vehicle) {
    	this.ShowVehiclePositionModel = true;      
    	setTimeout(() => {
    		this.$refs.VehicleMaps.SetVehicleId(vehicle.id)
    		this.$refs.VehicleMaps.ShowVehicleMaps()
    	},500);
    },

    showVehicleAssetsModel(AssetList){
      this.AssetsList = AssetList;
    	this.ShowVehicleAssetsModel = true;   
      setTimeout(() => {
    		this.$refs.VehicleAssetsPopups.ShowVehicleAssetPopup()
    	},500);   
    },
  },
};
